import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import ContentState, { getTerminals } from '../../../../stores/ContentState'
import TariffsSelect from '../../tariffs/TariffsSelect'
import './index.scss'
import { ReactComponent as Filter } from '../../../../assets/terminals/filter.svg'
import { SolutionTab } from '../../about/Solutions'
import { ReactComponent as Close } from '../../../../assets/tariffs/close.svg'
import { ReactComponent as Check } from '../../../../assets/terminals/check.svg'
import classNames from 'classnames'
import TerminalsTable from '../TerminalsTable'

import { ReactComponent as ListIcon } from '../../../../assets/terminals/list.svg'
import { ReactComponent as MapIcon } from '../../../../assets/terminals/map.svg'
import TerminalsList from '../TerminalsList'
import Map from '../../../common/Map/Map'
import TerminalCol from '../../terminal'
import { observable } from 'mobx'
import { terminalSort } from '../../../../mocks/terminalsSort'
import loader from '../../../../assets/loaders/np-preloader1.gif'
import { useLocation } from 'react-router'

export const Cities = observable({
  cities: null,
})

export const Terminals = observable({
  list: null,
})

const TerminalsCol = observer(() => {
  const [currentTerm, setTerm] = useState<any>(null)
  const [tab, setTab] = useState(0)
  const [showSub, setShowSub] = useState(false)
  const [state, setState] = useState({
    city: 'Київ',
    terminal: '',
    type: '',
    sundaywork: false,
    selfserve: false,
    worknow: false,
  })

  const { pathname } = useLocation()

  const icons = [<ListIcon />, <MapIcon />]
  const [isLoad, setLoad] = useState(true)
  const content = ContentState.terminals
  const [width, setWidth] = useState(window.innerWidth)
  const clear = () => {
    setState({
      ...state,
      city: 'Київ',
      terminal: '',
      type: '',
      sundaywork: false,
      selfserve: false,
      worknow: false,
    })
    setDt(Terminals.list)
  }

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  const [dt, setDt] = useState<any>(null)

  useEffect(() => {
    const city = (Cities.cities as any)?.find((c: any) => c.text == state.city)
    if (city) {
      getTerminals(city.name)
        .then(() => {
          setDt(Terminals.list)
        })
        .catch((e) => {
          const lang = pathname.includes('/en/')
            ? '/en/'
            : pathname.includes('/ru/')
            ? '/ru/'
            : '/'

          window.location.href = lang + 'error-api'
        })
    } else
      getTerminals(state.city).then(() => {
        setDt(Terminals.list)
      })
  }, [state.city, pathname])

  useEffect(() => {
    setState({ ...state, terminal: '' })
  }, [state.city])

  useEffect(() => {
    window.scroll(0, 0)
  }, [currentTerm])

  useEffect(() => {
    if (Terminals.list) {
      setLoad(false)
    } else setLoad(true)
  }, [Terminals.list])

  useEffect(() => {
    const list = JSON.parse(JSON.stringify(Terminals.list))

    if (
      !state.terminal.length &&
      !state.type.length &&
      !state.sundaywork &&
      !state.selfserve &&
      !state.worknow
    ) {
      setDt(list)
      return
    }
    const result = terminalSort(
      state.terminal,
      list,
      state.type,
      content,
      state.sundaywork,
      state.worknow,
      state.selfserve,
    )

    setDt([...result])
  }, [
    state.terminal,
    state.type,
    state.sundaywork,
    state.selfserve,
    state.worknow,
    Terminals.list,
  ])

  const getCoords = () => {
    if (!dt) return []
    ;(dt as any)?.map((d: any) => {
      d.typeEn = content.types.find((f: any) => {
        const t = d.type.split(' ')[0].slice(0, d.type.split(' ')[0].length - 2)
        return f.title?.includes(t)
      })?.type
    })

    return dt
  }

  let center = content.center
  if (dt && dt.length) {
    center = {
      lng: +dt[0].lng,
      lat: +dt[0].lat,
    }
  }

  if (!content) return <></>
  return (
    <>
      <section className="terminals-col">
        <div className="terminals-col__content">
          {!currentTerm && (
            <>
              <div className="terminals-col__title">{content.title}</div>
              <div className="terminals-col__top">
                <div className="terminals-col__selects">
                  <TariffsSelect
                    dt={
                      (Cities.cities as any)?.map((c: any) => {
                        return c.text
                      }) || []
                    }
                    isError={false}
                    isFlag={false}
                    showInput
                    defaultValue={content.cityPlaceholder}
                    value={
                      (Cities.cities as any)?.find(
                        (c: any) => c.name == state.city,
                      ).text || ''
                    }
                    getValue={(value) => {
                      const val = (Cities.cities as any)?.find(
                        (c: any) => c.text == value,
                      )

                      setState({ ...state, city: val.name })
                    }}
                  />

                  {!Terminals.list ? (
                    <TariffsSelect
                      dt={[]}
                      isError={false}
                      isFlag={false}
                      showInput
                      isTerminals
                      defaultValue={content.terminalPlaceholder}
                      value={state.terminal}
                      getValue={(value) =>
                        setState({ ...state, terminal: value })
                      }
                    />
                  ) : (
                    <TariffsSelect
                      dt={(Terminals.list as any)!.map((t: any) => {
                        return `${t.CityName}, №${t.number}`
                      })}
                      isTerminals
                      isError={false}
                      isFlag={false}
                      showInput
                      defaultValue={content.terminalPlaceholder}
                      value={state.terminal}
                      getValue={(value) =>
                        setState({ ...state, terminal: value })
                      }
                    />
                  )}
                </div>
                <div
                  className={classNames(
                    'terminals-col__filter',
                    showSub && 'active',
                  )}
                  onClick={() => setShowSub(!showSub)}
                >
                  <Filter />
                </div>
                <div className="terminals-col__tabs">
                  {content.tabs?.map((l: any, i: number) => (
                    <SolutionTab
                      title={width > 1365 ? l : icons[i]}
                      key={i}
                      active={tab == i}
                      setTab={(value) => setTab(i)}
                    />
                  ))}
                </div>
              </div>
              {showSub && (
                <div className="terminals-col__subtop">
                  {content.types && (
                    <TariffsSelect
                      dt={content.types?.map((t: any) => t.title)}
                      isError={false}
                      isFlag={false}
                      defaultValue={content.typePlaceholder}
                      value={state.type}
                      getValue={(value) => setState({ ...state, type: value })}
                    />
                  )}
                  <div className="terminals-col__checks">
                    <div
                      className="terminals-col__checkbox"
                      onClick={() => {
                        setState({ ...state, sundaywork: !state.sundaywork })
                      }}
                    >
                      <div
                        className={classNames(
                          'terminals-col__checkbox-check',
                          state.sundaywork && 'checked',
                        )}
                      >
                        <Check />
                      </div>
                      {content.sundaywork}
                    </div>
                    <div
                      className="terminals-col__checkbox"
                      onClick={() => {
                        setState({ ...state, selfserve: !state.selfserve })
                      }}
                    >
                      <div
                        className={classNames(
                          'terminals-col__checkbox-check',
                          state.selfserve && 'checked',
                        )}
                      >
                        <Check />
                      </div>
                      {content.selfserve}
                    </div>
                    <div
                      className="terminals-col__checkbox"
                      onClick={() => {
                        setState({ ...state, worknow: !state.worknow })
                      }}
                    >
                      <div
                        className={classNames(
                          'terminals-col__checkbox-check',
                          state.worknow && 'checked',
                        )}
                      >
                        <Check />
                      </div>
                      {content.worknow}
                    </div>
                  </div>
                </div>
              )}
              {(state.terminal.length ||
                state.type.length ||
                state.sundaywork ||
                state.selfserve ||
                state.worknow) && (
                <div className="terminals-col__clear" onClick={clear}>
                  <Close /> <span>{content.clear}</span>
                </div>
              )}
              {width > 700 && !tab && (
                <TerminalsTable content={content} dt={dt} setTerm={setTerm} />
              )}
              {width <= 700 && !tab && (
                <TerminalsList content={content} dt={dt} setTerm={setTerm} />
              )}
              {tab && !currentTerm ? (
                <div className="map" id="map">
                  {width > 700 && (
                    <div
                      className={classNames(
                        'tariffs__loader',
                        isLoad && 'loader',
                      )}
                    >
                      <img src={loader} />
                    </div>
                  )}
                  <div className="map__list">
                    {content.types
                      .filter((t: any) => t.type != 'punkt' && t.type != 'all')
                      ?.map((t: any, i: number) => (
                        <div className="map__item" key={i}>
                          <div
                            className={classNames('map-circle', t.type)}
                          ></div>
                          {t.title}
                        </div>
                      ))}
                  </div>
                  <Map
                    setTerm={setTerm}
                    details={[]}
                    center={center}
                    coords={getCoords()}
                    zoom={10}
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          )}
          {currentTerm && (
            <TerminalCol
              dt={currentTerm}
              setTerm={() => {
                setTerm(null)
                setTab(0)
              }}
            />
          )}
        </div>
      </section>
    </>
  )
})

export default TerminalsCol
